import React from 'react';
import PropTypes from 'prop-types';
import {
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
} from '@material-ui/core';
import {
  NkTable,
  NkTableHeaderCell,
  NkNoRecordsTableCell,
  NkTableCell,
} from '@nordkap/nordkap-ui';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { uniqueKey } from '../../utils/uniqueKey';

const PositionPreview = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <TableContainer>
      <div className={classes.TableLayoutAuto}>
        <NkTable>
          <TableHead>
            <TableRow key={uniqueKey()}>
              {props.tableHeader.length === 0 ? (
                <NkNoRecordsTableCell
                  noRecordsAvailableLabel={t('position.noHeaderFound')}
                  columnCount={5}
                />
              ) : (
                props.tableHeader.map(title => (
                  <NkTableHeaderCell key={uniqueKey()}>
                    {title}
                  </NkTableHeaderCell>
                ))
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.tableRows.length === 0 ? (
              <TableRow>
                <NkNoRecordsTableCell
                  noRecordsAvailableLabel={t(
                    'position.thisPositionWillNotAppearInAccounting'
                  )}
                  columnCount={5}
                />
              </TableRow>
            ) : (
              props.tableRows.map(row => (
                <TableRow key={uniqueKey()}>
                  {row.map(cell => (
                    <NkTableCell key={uniqueKey()}>{cell}</NkTableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </NkTable>
      </div>
    </TableContainer>
  );
};

PositionPreview.propTypes = {
  tableHeader: PropTypes.array,
  tableRows: PropTypes.array,
};

export default PositionPreview;
